import React from 'react';
import { ReactComponent as Edit } from 'Icons/CommandPanel/Edit.svg';
import { ReactComponent as Delete } from 'Icons/CommandPanel/Delete.svg';
import { ReactComponent as Print } from 'Icons/Sidebar/Print.svg';
import { IExperimentScreenLot } from 'business/models/Models';
import { showAlertSnackBar } from 'utils/Global';
import PlateService from 'business/services/PlateService';
import EAlertType from 'enums/EAlertType';
import ESnackBarPosition from 'enums/ESnackBarPosition';
import { useShowLabelPrinterError } from 'CustomHooks';

interface Props {
  lot: IExperimentScreenLot;
  canModify: boolean;
  onEdit: () => void;
  onDelete: () => void;
}

const actionClassName = (enabled: boolean) =>
  enabled ? 'cursor-pointer' : 'opacity-50 pointer-events-none';

export default function LotActions({ lot, canModify, onEdit, onDelete }: Props) {
  const showLabelPrinterError = useShowLabelPrinterError();

  const printScreenLotBarcode = async () => {
    showAlertSnackBar(EAlertType.INFO, ESnackBarPosition.TOP, 'Sent for print barcode.');
    const plateService = new PlateService();
    const printResponse = await plateService.printScreenLotBarcode(lot.id);
    if (printResponse.value != '') {
      showLabelPrinterError();
    }
  };

  return (
    <div
      id={`screenlot-lotcard-actions-${lot.id}`}
      className="flex ing-delete-update-enabled flex-space-between"
    >
      <Print
        id={`screenlot-lotcard-print-${lot.id}`}
        onClick={printScreenLotBarcode}
        className="cursor-pointer"
      />
      <Edit
        id={`screenlot-lotcard-edit-${lot.id}`}
        onClick={canModify ? onEdit : undefined}
        className={actionClassName(canModify)}
      />
      <Delete
        id={`screenlot-lotcard-delete-${lot.id}`}
        onClick={canModify ? onDelete : undefined}
        className={actionClassName(canModify)}
        style={{ visibility: lot.lotNumber === 0 ? 'hidden' : 'visible' }}
      />
    </div>
  );
}
